/* 财务-旅游包车 */
<template>
  <div id="ly_line">

    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns"
      :addText="btnPreFn('travel_line_add', false) ? '创建线路' : ''" @addFn="addLine">
      <!-- 操作 -->
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="128px">
          <div slot-scope="{row}" class="custom-action"
            v-if="btnPreFn('travel_line_vehicle', false) || btnPreFn('travel_line_edit', false) || btnPreFn('travel_line_delete', false)">
            <el-button v-if="btnPreFn('travel_line_vehicle', false)" type="text"
              @click="viewVehicle(row)">值班车辆</el-button>
            <el-dropdown @command="handleCommand($event, row)" style="margin-left: 10px;">
              <el-button type="text"
                v-if="btnPreFn('travel_line_edit', false) || btnPreFn('travel_line_delete', false)">更多</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="edit" v-if="btnPreFn('travel_line_edit', false)">编辑线路</el-dropdown-item>
                <el-dropdown-item command="delete" v-if="btnPreFn('travel_line_delete', false)">删除线路</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'fee'">
          <span v-for="item in JSON.parse(row.lineFeeAndDriverCommission)" :key="item.id" >
            <span>{{ item.vehicleSeat }}座车：{{ item.fee }}元&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </template>
        <template v-else-if="item.prop === 'driverCommission'">
          <span v-for="item in JSON.parse(row.lineFeeAndDriverCommission)" :key="item.id">
            <span>{{ item.vehicleSeat }}座车：{{ item.driverCommissionType === 1 ? '￥' + item.driverCommission :
              item.driverCommission + '%' }}&nbsp;&nbsp;</span>
          </span>
        </template>

        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default {
  name: "ly_line",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/travelLine",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "input", field: "startStationName", name: "出发地", value: "" },
          { type: "input", field: "endStationName", name: "目的地", value: "" },
        ],
      },
      // 表头
      columns: [
        { prop: "startStationName", label: "出发地", minWidth: 100 },
        { prop: "endStationName", label: "目的地", minWidth: 100 },
        { prop: "fee", label: "线路价格", minWidth: 150 },
        { prop: "driverCommission", label: "司机提成", minWidth: 150 },
      ],
    };
  },
  methods: {
    // 创建线路
    addLine() {
      this.$router.push({ path: '/ly_lineEdit' });
    },
    // 值班车辆
    viewVehicle(row) {
      this.$router.push({ path: '/ly_lineVehicle', query: { id: row.id, organizationId: row.organizationId, lineName: `${row.startStationName} - ${row.endStationName}` } });
    },
    handleCommand(command, row) {
      if (command === 'edit') {
        this.$router.push({ path: '/ly_lineEdit', query: { id: row.id } });
      } else if (command === 'delete') {
        this.$confirm('是否删除当前线路？', '删除线路', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let url = "/api/v1/manage/travelLine/";
          let { code } = await this.$axios.delete(url, {
            id: row.id
          })
          if (code === 1) {
            this.$message.success('删除成功');
            this.$refs.customTable.listFn();
          }
        }).catch(() => { });
      }
    },
  },
};
</script>

<style lang="less" scoped>
#ly_line {
  // 操作按钮样式
  .custom-action {
    display: flex;
    align-items: center;
    
    .el-button--text {
      padding: 0;
      color: #2B77FF;
      
      &:hover {
        color: #1a5fd9;
      }
    }
    
    .el-dropdown {
      .el-button--text {
        color: #2B77FF;
        
        &:hover {
          color: #1a5fd9;
        }
      }
    }
  }
}
</style>
